// Header
export const DOCUMENT_TYPE = "documentTypeId";
export const DOCUMENT_ID="documentId";
export const BILLING_MONTH_YEAR = "billingMonthYear";
export const BILLING_DATE = "billingRunDate";
export const BILLING_AMOUNT = "amount";
export const DUE_DATE = "dueDate";
export const TRANSACTION_TYPE = "transactionType";
export const GL_ACCOUNT = "glMasterId";
export const PAYMENT_TERM = "paymentTerm";
export const COMMENT = "comment";
export const POSTING_DATE = "postingDate";
export const POSTING_MONTH = "postingMonth";
export const YEAR = "postingYear";
export const LINE_ITEM_TYPE="lineItemType";


// line items
export const LINE_ITEMS = "lineItems";
export const CHECK = "check";
export const BILLING_CATEGORY = "categoryName";
export const PROPERTY_MODEL = "modelName";
export const PROPERTY_BLOCK = "blockName";
export const PROPERTY_ID = "propertyId";
export const PROPERTY_NAME = "name";
export const UNIT_NO = "unitNumber";
export const STREET_ADDRESS = "addressLine1";
export const CURR_OWNER_ID = "ownershipId";
export const CURR_OWNER_LAST_NAME = "lastName";
export const DRCR = "drCr";
export const LINE_BILLING_AMOUNT = "amount";
export const ITEM_TEXT = "itemText";

export const drcrOptions = [
  { label: "Dr", value: "DR" },
  { label: "Cr", value: "CR" },
];
